export class CompanyGroupSearch {
    id: string;
    name: string;
    skip: number = 0;
    limit: number = 10;
    totalItems: number = 0;
    active: Boolean = true;
    allItems: Boolean = false;
}


// WEBPACK FOOTER //
// ./src/app/models/CompanyGroupSearch.model.ts